const setStateMutation = (state, payload) => {
  Object.assign(state, payload);
};

const setPageMutation = (state, payload) => {
  Object.assign(state, { page: payload });
};

const appendPillsMutation = (state, payload) => {
  state.pills.push(...payload);
};



const mutations = {
  setState: setStateMutation,
  setPage: setPageMutation,
  appendPills: appendPillsMutation,
};

export default mutations;
